import { render, staticRenderFns } from "./endo.vue?vue&type=template&id=bb685c48"
import script from "./endo.vue?vue&type=script&lang=js"
export * from "./endo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports